import {Component, OnInit} from '@angular/core';
import {SecurityData} from "../security-data";

@Component({
  selector: 'cap-unsupported',
  templateUrl: './unsupported.component.html',
  styleUrls: ['./unsupported.component.scss']
})
export class UnsupportedComponent implements OnInit {

  constructor(public securityData: SecurityData) {
  }

  ngOnInit() {
  }

}
